import React from 'react';
import styled, {css} from 'styled-components';
import {graphql, StaticQuery} from 'gatsby';
import {mediaQueries, maxMediaQueries} from '../utils/styling';

const BreakingNewsContainer = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 42px;
	background-color: ${p => p.backgroundColor};
  color: ${p => p.textColor};
  
	font-family: Montserrat;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 24px;
	
	z-index: 100;

  ${maxMediaQueries.sm`
  	flex-direction: column;
  	height: 100px;
  `};
`;

const BreakingNewsImagesContainer = styled.div`
	display: flex;
    flex-direction: row;
    text-align: center;
 `;

const BreakingNewsMiurosLogo = styled.img.attrs(props => ({
  src: props.src
}))`
	height: 18px;
	margin-right: 7px;
	${maxMediaQueries.sm`
  		padding: 3px;
  		height: 24px;	
  `};
`;

const BreakingNewsEventLogo = styled.img.attrs(props => ({
  src: props.src
}))`
	height: 18px;
	margin-left: 7px;
	margin-right: 14px;
	${maxMediaQueries.sm`
  		padding: 3px;	
  		height: 24px;
  `};
`;

const BreakingNewsText = styled.div`
	display: flex;
  flex-direction: column;
  text-align: center;

	font-family: Montserrat, sans-serif;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 24px;
	
	${maxMediaQueries.sm`
		padding: 4px;
		font-size: 11px;
  `};
`;

const BreakingNewsPlaceholder = styled.div`
	height: 42px;
	
  ${maxMediaQueries.sm`
  	height: 100px;
  `};
`;

const StyledMain = styled.main`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const MainWithBanner = ({props, children}) => (
    <>
      <StaticQuery
          query={graphql`
      query {
        allContentfulEventBanner {
	      nodes {
	        eventText
	        textColor
	        backgroundColor
	        enabled
	        eventLogo{
	          file{
	            url
	          }
	        }
	        miurosLogo{
	          file{
	            url
	          }
	        }
	      }
	    }
     }
  `}
          render={data => (
              <>
                {data && data.allContentfulEventBanner.nodes[0].enabled ?
                    <>
                      <BreakingNewsContainer
                          id="newscontainer"
                          textColor={data.allContentfulEventBanner.nodes[0].textColor}
                          backgroundColor={data.allContentfulEventBanner.nodes[0].backgroundColor}>
                        <BreakingNewsImagesContainer>
                          <BreakingNewsMiurosLogo src={data.allContentfulEventBanner.nodes[0].miurosLogo.file.url}/>
                          <span>@</span>
                          <BreakingNewsEventLogo src={data.allContentfulEventBanner.nodes[0].eventLogo.file.url}/>
                        </BreakingNewsImagesContainer>
                        <BreakingNewsText
                            dangerouslySetInnerHTML={{__html: data.allContentfulEventBanner.nodes[0].eventText}}/>
                      </BreakingNewsContainer>
                      <BreakingNewsPlaceholder/>
                    </>
                    : null
                }
              </>
          )}
      />
      <StyledMain>{children}</StyledMain>
    </>
);

